<script>
    export let text;
    export let rate = 200;

    let dictionary;
    let targetLines;
    let lines;

    $: needsUpdate = lines.some((line, index) => line !== targetLines[index]);

    $: (() => {
        if (lines) {
            targetLines = text
                .split(/\n/)
                .map((line, index) =>
                    line.padEnd(Math.max(line.length, lines[index].length), " ")
                );

            lines = lines.map((line, index) =>
                line.padEnd(
                    Math.max(
                        line.length,
                        targetLines[index] ? targetLines[index].length : 0
                    ),
                    " "
                )
            );

            dictionary = targetLines.map((line, index) => line.split(""));
        } else {
            targetLines = text ? text.split(/\n/) : ["", ""];
            lines = targetLines;
        }
    })();

    function update() {
        lines = lines.map((line, lineIndex) =>
            line
                .split("")
                .map((c, charIndex) => {
                    if (
                        lineIndex > targetLines.length - 1 ||
                        charIndex > targetLines[lineIndex].length - 1
                    ) {
                        return c;
                    }

                    if (c === targetLines[lineIndex][charIndex]) {
                        return c;
                    }

                    return dictionary[lineIndex][
                        Math.trunc(Math.random() * dictionary[lineIndex].length)
                    ];
                })
                .join("")
        );

        if (needsUpdate) {
            setTimeout(update, rate);
        }
    }

    $: needsUpdate && update();
</script>

<div class="display">
    {#each lines as line}
        <div>{@html line}</div>
    {/each}
</div>

<style>
    .display {
        cursor: default;
        background: black;
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
    }

    .display div {
        box-sizing: border-box;
        width: 100%;
        padding: 0 calc(var(--chrome-depth) * 3);
        padding-bottom: var(--chrome-depth);
        overflow: hidden;
        color: darkgoldenrod;
        font-size: 11px;
        font-family: courier, courier new, monospace;
        line-height: 11px;
        white-space: pre;
        text-transform: uppercase;
        text-overflow: clip;
        text-shadow: 0 2px 2px darkgoldenrod;
    }

    .display div:first-child {
        padding-top: calc(var(--chrome-depth) * 3);
    }

    .display div:last-child {
        padding-bottom: calc(var(--chrome-depth) * 3);
    }
</style>
